/* eslint-disable @typescript-eslint/explicit-member-accessibility */
export enum FrontendMessageType {
  UserId = 'userId',
  AccessToken = 'accessToken',
  Logout = 'logout',
}

export enum FrontendRequestType {
  Purchase = 'purchase',
  Purchase_History = 'purchase_history',
  ValidateReceipt = 'validateReceipt',
}

export enum PurchaseItem {
  SUBSCRIPTION_MONTHLY = 'Monthly',
  SUBSCRIPTION_YEARLY = 'Yearly',
}

export enum MobileAppResponseType {
  Purchase_Success = 'purchase_success',
  Purchase_Failed = 'purchase_failed',
  Purchase_History = 'purchase_history',
  Purchase_History_Failed = 'purchase_history_failed',
  Available_Purchases = 'available Purchases',
  Available_Purchases_Failed = 'available Purchases_failed',
  ValidateReceipt_Success = 'validateReceipt_success',
  ValidateReceipt_Failed = 'validateReceipt_failed',
  ReadyPlayerMe = 'readyPlayerMe',
  Message = 'message',
}

export interface FrontendMessage {
  type: FrontendMessageType
  payload?: string
}

export interface FrontendRequest {
  type: FrontendRequestType
  payload: PurchaseItem
}

export interface MobileAppResponse {
  type: MobileAppResponseType
  payload?: SubscriptionPurchase | string | Purchase[] | undefined
  origin?: string
}

export interface GooglePurchaseReceipt {
  packageName: string
  subscriptionId: string
  token: string
}

export enum PurchaseStateAndroid {
  UNSPECIFIED_STATE = 0,
  PURCHASED = 1,
  PENDING = 2,
}

export enum TransactionReason {
  PURCHASE = 'PURCHASE',
  RENEWAL = 'RENEWAL',
}

export interface ProductPurchase {
  productId: string
  transactionId?: string
  transactionDate: number
  transactionReceipt: string
  purchaseToken?: string
  // iOS
  quantityIOS?: number
  originalTransactionDateIOS?: number
  originalTransactionIdentifierIOS?: string
  verificationResultIOS?: string
  appAccountToken?: string
  // Android
  productIds?: string[]
  dataAndroid?: string
  signatureAndroid?: string
  autoRenewingAndroid?: boolean
  purchaseStateAndroid?: PurchaseStateAndroid
  isAcknowledgedAndroid?: boolean
  packageNameAndroid?: string
  developerPayloadAndroid?: string
  obfuscatedAccountIdAndroid?: string
  obfuscatedProfileIdAndroid?: string
  // Amazon
  userIdAmazon?: string
  userMarketplaceAmazon?: string
  userJsonAmazon?: string
  isCanceledAmazon?: boolean
}

export interface SubscriptionPurchase extends ProductPurchase {
  autoRenewingAndroid?: boolean
  originalTransactionDateIOS?: number
  originalTransactionIdentifierIOS?: string
  verificationResultIOS?: string
  transactionReasonIOS?: TransactionReason | string
}

export interface GoogleFrontendReceipt {
  redirect_status: string
  confirmation_number: string
  created: string
  trialDays: string
  countryCode: string
  priceId: string
}
export type Purchase = ProductPurchase | SubscriptionPurchase
